import { useState } from "react";
import { useSelector } from "react-redux";
import { CarEntity } from "../../../../../entities/ServicesEntities/UserEntities/CarEntity";
import { CarOperationsEntity } from "../../../../../entities/ServicesEntities/UserEntities/CarOperationsEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
  SCOPE_TYPE
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as carActionsService from "../../../../../services/ActionsService/CarActionsService";
import { refreshSingleUserDataAndExtended } from "../../../../../services/ParkerService";
import {
  showErrorMessage,
  showUpdateCarErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import AddCarsStep from "../Steps/AddCarsStep";
import classes from "../WizardForm.module.css";

const AddCarsForm = (props) => {
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const selectedSites = useSelector((state) => state.user.selectedSites);
  const selectedSite = selectedSites[0];


  // if selectedScope is not project set currentSiteId to null (siteId is not known yet)
  // and the siteId will be defined by the token's siteId
  const currentSiteId = props.isEditMode
    ? props?.car?.currentSiteId
    : selectedScope?.type !== SCOPE_TYPE.PROJECT ? null : selectedSite.id;


  // sites prev code
  // const currentSiteId = props.isEditMode
  //   ? props?.car?.currentSiteId
  //   : selectedSite.id;

  // sites prev code
  const currentSite = useSelector((state) => state.user.sites)?.find(
    (site) => site.id === currentSiteId
  );

  //all tokens that assign to user in current site
  const formTokens = props?.carUserTokens?.filter((token) => token.siteId === currentSiteId);

  const [formData, setFormData] = useState({
    cars: props.car ? [props?.car] : [],
    carUserTokens: formTokens ?? [],
    // defaultCarToken: props.isEditMode ? props?.car?.assignCarToken : null,
    defaultCarToken: props.isEditMode ? props?.car?.assignCarToken?.filter((assignCarToken) => assignCarToken.siteId === props.parentSite.id) : null,
    isStepSubmitted: false,
  });
  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.ADD_CARS,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { cars, carsTokens } = formData;

    if (stateData.isCurrentStepValid) {
      const carId = props.isEditMode ? cars[0].id : 0;
      const userId = props?.utronUser?.id;
      const siteId = currentSiteId === null ? cars[0].token?.siteId : currentSiteId;
      const tokenId = cars[0].token?.id;
      const carToCreate = new CarEntity();

      if (props.isEditMode) {
        // handle circular at carEntity - parkingHistories contains circular reference with carUserTokens -> user
        // therefore copying utronUser with parkingHistories excluded
        let {parkingHistories, ...utronUserCopy} = cars[0].utronUser;
        let {...carCopy} = cars[0];
        carCopy.utronUser = utronUserCopy;
        Object.assign(carToCreate, { ...carCopy });
      } else {
        Object.assign(carToCreate, { ...cars[0] }); 
      } 
       
      carToCreate.currentSiteId = siteId;
      let carOperationsEntity = new CarOperationsEntity(
        carId,
        userId,
        siteId,
        carToCreate,
        buildCarTokensObject(tokenId, carId)
      );
      carOperationsEntity.carTokens?.forEach((carToken) => carToken.user = null);
      
      let action = null;
      if (props.isEditMode) {
        // handle circular on carTokens - sets the utronUser without parkingHistory circular reference
        if (carOperationsEntity.carTokens.length !== 0 && carOperationsEntity.carTokens[0].car?.utronUser) {
          carOperationsEntity.carTokens[0].car.utronUser = carOperationsEntity.carEntity.utronUser; // utronUserCopy;
        }

        action = carActionsService.updateCar(carOperationsEntity, true, false);
      } else {
        action = carActionsService.addCar(carOperationsEntity, true, false);
      }

      action.then((response) => {
        if (response.data.isSuccess) {
          store.dispatch(userActions.setUserCarTokens({ userId, ...response.data.entity }));                    
          // triggers the ParkerDetails to render Accordion again,
          // check option to update user's car details          
          store.dispatch(commonActions.closeSideModal());
          if (userId) {
            refreshSingleUserDataAndExtended(userId, null, null, true, false)
            .then(() => {
              store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              showUpdateSuccessMessage();
            })
            .catch((refreshError) => {
              console.error('Error refreshing user data after car operation:', refreshError);
            });
          }

          // actionsService
          //   .getUserSites()
          //   .then((response) => {
          //     store.dispatch(userActions.setSites(response.data.entity));
          //   })
          //   .then(() => {
          //     store.dispatch(userActions.setUsersSite(selectedSite.id));
          //     showUpdateSuccessMessage();
          //     store.dispatch(commonActions.closeSideModal());
          //   });
          // store.dispatch(userActions.setParkersAndGuests());
        } else {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          showUpdateCarErrorMessage(response.data?.error);
        }
      }).catch(error => {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));          
      });
    }
  };

  const buildCarTokensObject = (tokenIdToUpdate, carId) => {
    let carTokensToUpdate = [];

    let oldCarTokens = null;

    // if (props.isEditMode) {
    //   oldCarTokens = formData.defaultCarToken[0] ? currentSite?.tokens?.find(
    //     (token) => token.id === formData.defaultCarToken[0]?.id
    //   )?.carUserTokens[0]
    //     :
    //     null;
    // }

    if (props.isEditMode) {
      oldCarTokens = formData.defaultCarToken[0] ? props?.utronUser?.carUserTokens?.find(
        (carUserToken) => carUserToken.tokenId === formData.defaultCarToken[0]?.id)
        :
        null;
    }

    if (oldCarTokens && oldCarTokens.tokenId !== tokenIdToUpdate) {
      carTokensToUpdate = buildUpdateCarTokenObject(
        tokenIdToUpdate,
        oldCarTokens
      );
    } else {
      carTokensToUpdate = buildNewCarTokenObject(tokenIdToUpdate, carId);
    }

    return carTokensToUpdate;
  };

  const buildUpdateCarTokenObject = (tokenIdToUpdate, oldCarTokens) => {
    let carTokensToUpdate = [];
    //update new car token
    // if (tokenIdToUpdate && tokenIdToUpdate !== formData.defaultCarToken ? formData.defaultCarToken[0]?.id : formData.carUserTokens.find((carUserToken) => carUserToken.id === tokenIdToUpdate)) {
    if (tokenIdToUpdate && tokenIdToUpdate != formData.defaultCarToken?.id) {
      let currentCarToken = props?.utronUser?.carUserTokens?.find(
        (carUserToken) => carUserToken.tokenId === tokenIdToUpdate)

      if (oldCarTokens) {
        currentCarToken = {
          ...currentCarToken,
          carId: oldCarTokens.carId,
          isOccupied: oldCarTokens.isOccupied,
          car: oldCarTokens.car,
        };
      }

      carTokensToUpdate.push(currentCarToken);
    }
    //update old car token
    if (oldCarTokens) {
      oldCarTokens = {
        ...oldCarTokens,
        carId: null,
        isOccupied: false,
        car: null,
      };
      carTokensToUpdate.push(oldCarTokens);
    }

    return carTokensToUpdate;
  };

  const buildNewCarTokenObject = (tokenIdToUpdate, carId) => {
    const { cars } = formData;
    let carTokensToUpdate = [];

    if (tokenIdToUpdate) {
      let currentCarToken = null;

      currentCarToken = props.utronUser.carUserTokens?.find((carUserToken) => carUserToken.tokenId === tokenIdToUpdate);

      currentCarToken = { ...currentCarToken, carId: carId, isOccupied: true, car: cars[0] };
      carTokensToUpdate.push(currentCarToken);
    }

    return carTokensToUpdate;
  };

  return (
    <form name="AddCarsForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <AddCarsStep
          isEditMode={props.isEditMode}
          currentStep={stateData.currentStep}
          totalSteps={stateData.totalSteps}
          id={INPUTS_PROPS.CARS}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          selectedSite={selectedSite}
          defaultCarTokenId={formData?.defaultCarToken?.value}
          parentSite={props.parentSite}
          utronUser={props.utronUser}
          {...formData}
        />
      </div>
      <div className={classes.next}>
        <EllipseButton type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
      </div>
    </form>
  );
};

export default AddCarsForm;
